import React from 'react';
import Backdrop from 'components/Backdrop';
import Button from 'components/Button';

import './index.css';

type PopupProps = {
    title?: string;
    primaryButtonText?: string;
    primaryButtonOnClick?: () => void;
    secondaryButtonText?: string;
    secondaryButtonOnClick?: () => void;
    children?: React.ReactNode;
    innerRef?: React.RefObject<HTMLDivElement>;
}

function Popup({
    title,
    primaryButtonText,
    primaryButtonOnClick,
    secondaryButtonText,
    secondaryButtonOnClick,
    children,
    innerRef
}: PopupProps) {
    return (
        <>
            <Backdrop />
            <div className='popup' ref={innerRef}>
                <h1 className='popup__title'>{title}</h1>
                {children}
                <div className='popup__buttonGroup'>
                    {primaryButtonText &&
                        <Button
                            className='popup__button'
                            onClick={primaryButtonOnClick}
                        >
                            {primaryButtonText}
                        </Button>
                    }
                    {secondaryButtonOnClick &&
                        <Button
                            className='popup__button'
                            onClick={secondaryButtonOnClick}
                            secondary
                        >
                            {secondaryButtonText}
                        </Button>
                    }
                </div>
            </div>
        </>
    );
}

export default Popup;